var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.192,
    height: 9.7,
    viewBox: "0 0 11.192 9.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(811.514 614.768)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-811.514 -651.308)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#767676",
    d: "M10.755,38.47A1.438,1.438,0,0,0,9.7,38.032H8.394l-.3-.793a1.083,1.083,0,0,0-.405-.493,1.038,1.038,0,0,0-.6-.207H4.1a1.038,1.038,0,0,0-.6.207,1.083,1.083,0,0,0-.405.493l-.3.793H1.492a1.438,1.438,0,0,0-1.055.437A1.438,1.438,0,0,0,0,39.525v5.223A1.438,1.438,0,0,0,.437,45.8a1.438,1.438,0,0,0,1.055.437H9.7a1.493,1.493,0,0,0,1.492-1.492V39.525A1.438,1.438,0,0,0,10.755,38.47ZM7.441,43.981a2.515,2.515,0,0,1-1.845.767,2.515,2.515,0,0,1-1.845-.767,2.6,2.6,0,0,1,0-3.69A2.515,2.515,0,0,1,5.6,39.525a2.515,2.515,0,0,1,1.845.767,2.6,2.6,0,0,1,0,3.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#767676",
    d: "M193.535,228.4a1.682,1.682,0,1,0,1.186.493A1.617,1.617,0,0,0,193.535,228.4Z",
    transform: "translate(-187.939 -187.946)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.999b9991.svg";
export { ForwardRef as ReactComponent };